import '@fortawesome/fontawesome-pro/css/all.css';
import 'bootstrap/dist/css/bootstrap.css';
import './sass/app.scss';

import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

const dsn = process.env.VUE_APP_SENTRY_DSN;
const release = process.env.VUE_APP_RELEASE;
dsn && Sentry.init({
  dsn,
  release,
  integrations: [new VueIntegration({Vue, attachProps: true})],
});

// Include Vue Components
import AddressCard from './Elements/AddressCard.vue';
Vue.component('addresscard', AddressCard);
import Alert from './Elements/Alert.vue';
Vue.component('alert', Alert);
import Banner from './Elements/Banner.vue';
Vue.component('banner', Banner);
import Modal from './Elements/Modal.vue';
Vue.component('modal', Modal);
import ElementCard from './Elements/Card.vue';
Vue.component('card', ElementCard);
import ElementCardTab from './Elements/CardTab.vue';
Vue.component('cardtab', ElementCardTab);
import ElementCardBanner from './Elements/CardBanner.vue';
Vue.component('cardbanner', ElementCardBanner);
import FormField from './Elements/FormField.vue';
Vue.component('field', FormField);
import FormOption from './Elements/FormOption.vue';
Vue.component('foption', FormOption);
import QuantityField from './Elements/QuantityField.vue';
Vue.component('quantityfield', QuantityField);
import FormSection from './Elements/FormSection.vue';
Vue.component('sect', FormSection);
import PagedList from './Elements/PagedList.vue';
Vue.component('pagedlist', PagedList);
import ProgressBar from './Elements/ProgressBar.vue';
Vue.component('progressbar', ProgressBar);
import FileUploader from './Elements/FileUploader.vue';
Vue.component('fileuploader', FileUploader);
import ImageList from './Elements/ImageList.vue';
Vue.component('imagelist', ImageList);
import Cart from './Elements/Cart.vue';
Vue.component('cart', Cart);
import Steps from './Elements/Steps.vue';
Vue.component('steps', Steps);
import Step from './Elements/Step.vue';
Vue.component('step', Step);
import Attachment from './Elements/Attachment.vue';
Vue.component('attachment', Attachment);

// Add Filter Mixin
import FiltersMixin from './Mixins/Filters.js';
Vue.mixin(FiltersMixin);

// Initialize Laravel's CSRF Token
// const token = document.querySelector('#app').getAttribute('data-token');

// Add i18n localization
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

// Initialize VueResource HTTP Client
import VueResource from 'vue-resource';
Vue.use(VueResource);

// Add cookie management
import VueCookie from 'vue-cookie'
Vue.use(VueCookie);

import deepmerge from 'deepmerge';

// import 'cookieconsent/build/cookieconsent.min.css';
// import  'cookieconsent';

const cookieconsent = window['cookieconsent'];
let dynamicCounter = 100000;

function registerDynamicComponents(obj) {
  if (Array.isArray(obj)) {
    for (const item of obj) {
      registerDynamicComponents(item);
    }
    return
  }

  if (obj && typeof obj === 'object') {
    for (const key of Object.keys(obj)) {
      if (key === 'component' && typeof obj.component === 'function') {
        const id = `dynamic_${(++dynamicCounter).toString(36)}`;
        const component = obj.component;
        console.log('registering', id, component);
        Vue.component(id, component);
        obj.component = id;
      } else {
        registerDynamicComponents(obj[key]);
      }
    }
  }
}

export function setup(appConfig, url) {

  registerDynamicComponents(appConfig);

  let isEmbeddedMode = window.location.search.startsWith('?embed');
  let isPrintMode = window.location.search.startsWith('?print');
  const embeddedToken = isEmbeddedMode ? window.location.search.substr(7) : null;
  const options = window.location.hash
    .substr(1)
    .split('&')
    .map(x => x.split('=').map(y => decodeURIComponent(y)))
    .reduce((a, [k, v]) => (a[k]=v,a), {});

  const messages = {
    en: require('./Locale/en.js').default,
    de: require('./Locale/de.js').default,
  };

  if (typeof appConfig.locales === 'object') {
    Object.keys(appConfig.locales).forEach((lang) => {
      messages[lang] = deepmerge(messages[lang] ?? {}, appConfig.locales[lang]);
    });
  }

  const i18n = new VueI18n({
    locale: options.locale || 'de',
    messages: messages,
    silentTranslationWarn: true,
  })

  function i18nFactory(original) {
    return function (label, opts) {
      let translated = '';
      if (typeof label == 'object' && label !== null) {
        translated = label[i18n.locale] ?? label['en'] ?? Object.values(label)[0] ?? JSON.stringify(label);
      } else {
        translated = original.call(this, label);
      }
      if (opts) {
        translated = translated.replace(/{([a-z_][a-z0-9_]*)}/gi, (def, token) => opts[token] ?? def);
      }
      return translated;
    }
  }

  i18n.t = i18nFactory(i18n.t);
  Vue.prototype.$t = i18nFactory(Vue.prototype.$t);

  const gaTracker = process.env.VUE_APP_GA_TRACKER_ID;
  if (isPrintMode || isEmbeddedMode) {
    window[`ga-disable-${gaTracker}`] = true;
  }

  // if (appConfig.cookieconsent !== false && !isPrintMode && !isEmbeddedMode) {
  //   const gaTracker = process.env.VUE_APP_GA_TRACKER_ID;
  //   function cookieConsentHandler() {
  //     var type = this.options.type;
  //     var didConsent = this.hasConsented();
  //     if (type === 'opt-in' && didConsent) {
  //       // enable cookies
  //       delete window[`ga-disable-${gaTracker}`];
  //     }
  //     if (type === 'opt-out' && !didConsent) {
  //       // disable cookies
  //       window[`ga-disable-${gaTracker}`] = true;
  //     }
  //   }

  //   const {content = {}, cookie = {}, ...cfg} = appConfig.cookieconsent || {};
  //   const options = {
  //     layout: 'basic',
  //     position: 'bottom',
  //     type: 'opt-out',
  //     ...cfg,
  //     cookie: {
  //       domain: window.location.host,
  //       revokable: true,
  //       ...cookie,
  //     },
  //     content: {
  //       header: i18n.t( content.header || 'CookieConsent.header'),
  //       message: i18n.t( content.message || 'CookieConsent.message'),
  //       dismiss: i18n.t( content.dismiss || 'CookieConsent.dismiss'),
  //       allow: i18n.t( content.allow || 'CookieConsent.allow'),
  //       deny: i18n.t( content.deny || 'CookieConsent.deny'),
  //       link: i18n.t( content.link || 'CookieConsent.link'),
  //       policy: i18n.t( content.policy || 'CookieConsent.policy'),
  //       href: 'https://www.cookiesandyou.com',
  //       close: '&#x274c;',
  //       target: '_blank',
  //     },
  //     onInitialise: cookieConsentHandler,
  //     onStatusChange: cookieConsentHandler,
  //     onRevokeChoice: cookieConsentHandler,
  //   };
  //   setTimeout(() => {
  //     cookieconsent.initialise(options);

  //     setTimeout(() => {
  //       if (window.ga) {
  //         window['ga']('create', process.env.VUE_APP_GA_TRACKER_ID, 'auto');
  //         window['ga']('send', 'pageview');
  //       }
  //     }, 1);
  //   }, 1);
  // }

  document.querySelector('#app').classList.add(appConfig.appClass || 'demo');

  if (appConfig.footer) {
    document.querySelector('body').innerHTML += '<footer-container>' + i18n.t(appConfig.footer) + '</footer-container>';
  }

  Vue.http.interceptors.push((request, next) => {
    if (request.url.indexOf(url) > -1) {
      // request.headers.set('X-CSRF-TOKEN', token);

      if (i18n.locale) {
        request.headers.set('x-locale', i18n.locale);
      }

      if (isEmbeddedMode && embeddedToken) {
        request.headers.set('Authorization', `Bearer ${embeddedToken}`);
      }
    }
    next();
  });

  appConfig.url = url;
  appConfig.imageFilter = /[a-z0-9]-(x|y|z|-z|i)\.png$/;

  appConfig.features = appConfig.features || {};

  new Vue({
    i18n,
    // el: '#app',
    data: appConfig,
    created() {
      if (isEmbeddedMode || isPrintMode) {
        document.body.classList.add('embeded');
      }
    },
    computed: {
      isEmbeddedMode() { return isEmbeddedMode || isPrintMode; },
      isPrintMode() { return isPrintMode; },
      currentUser() {
        const [component] = this.$children;
        return component?.currentUser;
      },
      cookieconsentConfig() {
        return appConfig.cookieconsent;
      },
      gaTracker() {
        return gaTracker;
      }
    },
    methods: {
      sentry(callback) {
        // TODO fix this
        // if (typeof Sentry != 'undefined') {
        //   // callback(Sentry);
        //   return true;
        // }

        return false;
      },
      getLocaleProperty(prop) {
        if (Object.keys(this).indexOf(prop) < 0)
          return null;

        return this.$t(this[prop]);
      },
      getLabelText(label) {
        return this.$t(label);
      },
      isTrue(prop) {
        return Object.keys(this).indexOf(prop) >= 0 ? this[prop] : false;
      },
      getWorkFlowSettings(type) {
        return appConfig.workflows[type] ?? {};
      }
    },
    render: h => h(App, {props: {imgPath: '/img', useLocale: options.locale }}),
  }).$mount('#app-frame');
}

